import axios from 'axios';

export const fetchUsers = async (setMines, setError, setLoading) => {
    try {
        const response = await axios.get('https://adapt-api.softmining.it/mines', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        console.log(response.data.data);
        setMines(response.data.data);
    } catch (err) {
        setError(err.response?.data?.message || err.message);
    } finally {
        setLoading(false);
    }
};

export const addTokens = async (mineId, tokenAmount) => {
    try {
        const response = await axios.post(`https://adapt-api.softmining.it/mines/${mineId}/tokens`,
            { tokens: tokenAmount },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );
        return response.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || err.message);
    }
};